import { Link } from 'react-router-dom';
import { useAdvisor } from '@/components/feature/AdvisorProvider';
import { trackContact } from '@/hooks/usePixel';

export default function Footer() {
  const { wapp } = useAdvisor();

  return (
    <footer className="bg-aa-black relative overflow-hidden">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <img
                src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/6a4c539fa89c00c807224a1f56b25f83.png"
                alt="Alianza Andina Empresarial"
                className="h-12 w-auto object-contain mb-6"
              />
              <p className="text-aa-gray-400 text-sm leading-relaxed">
                Firma especializada en financiamiento privado estructurado para proyectos de infraestructura, agroindustria, hotelería y desarrollo empresarial en Latinoamérica.
              </p>
            </div>

            {/* Navigation Column 1 */}
            <div>
              <h4 className="text-aa-gold text-xs uppercase tracking-[0.2em] font-semibold mb-6">
                Navegación
              </h4>
              <ul className="space-y-3">
                {['Inicio', 'Servicios', 'Proyectos', 'Nosotros', 'Testimonios', 'Contacto'].map((item) => (
                  <li key={item}>
                    <a
                      href={`#${item.toLowerCase()}`}
                      className="text-aa-gray-300 hover:text-aa-gold transition-colors text-sm whitespace-nowrap"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services Column */}
            <div>
              <h4 className="text-aa-gold text-xs uppercase tracking-[0.2em] font-semibold mb-6">
                Servicios
              </h4>
              <ul className="space-y-3">
                {['Capital de Infraestructura', 'Financiamiento Agroindustrial', 'Crédito Hotelero', 'Logística y Puertos', 'Desarrollo Inmobiliario', 'Capital de Trabajo'].map((item) => (
                  <li key={item}>
                    <span className="text-aa-gray-300 text-sm">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div>
              <h4 className="text-aa-gold text-xs uppercase tracking-[0.2em] font-semibold mb-6">
                Contacto
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-aa-gold mt-0.5 text-sm" />
                  <span className="text-aa-gray-300 text-sm">Cali, Valle del Cauca, Colombia</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-aa-gold mt-0.5 text-sm" />
                  <span className="text-aa-gray-300 text-sm">alianzaandina01@gmail.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-global-line text-aa-gold mt-0.5 text-sm" />
                  <span className="text-aa-gray-300 text-sm">alianzaandinaempresarial.com</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="gold-line my-10" />

          {/* Bottom Row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-3 text-xs text-aa-gray-500">
              <span>&copy; 2026 Alianza Andina Empresarial. Todos los derechos reservados.</span>
              <span className="hidden sm:inline text-aa-gold">|</span>
              <div className="flex items-center gap-3">
                <Link to="/" className="hover:text-aa-gold transition-colors whitespace-nowrap">Términos</Link>
                <Link to="/" className="hover:text-aa-gold transition-colors whitespace-nowrap">Privacidad</Link>
                <Link to="/" className="hover:text-aa-gold transition-colors whitespace-nowrap">Compliance</Link>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-aa-gray-700 text-aa-gray-300 hover:border-aa-gold hover:text-aa-gold transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a
                href={wapp}
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackContact}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-aa-gray-700 text-aa-gray-300 hover:border-aa-gold hover:text-aa-gold transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-sm" />
              </a>
              <a
                href="mailto:contacto@alianzaandina.com"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-aa-gray-700 text-aa-gray-300 hover:border-aa-gold hover:text-aa-gold transition-colors"
                aria-label="Email"
              >
                <i className="ri-mail-line text-sm" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}